module.exports = __webpack_public_path__ + "img/waiting-orange.3f47f694.svg";